module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-form-table', {
    staticClass: "product-table",
    attrs: {
      "form": _vm.form,
      "list": _vm.currentStockProducts,
      "additionalButtons": _vm.additionalButtons,
      "update": _vm.update,
      "destroy": _vm.destroy,
      "translation": _vm.translation,
      "disableForm": _vm.checkWarehouse,
      "clickHandler": _vm.tableClickHandler,
      "isImport": _vm.isImport,
      "isExport": _vm.isExport,
      "exportClickHandler": _vm.exportClickHandler,
      "server": _vm.server,
      "hiddenFields": _vm.hiddenFields
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7994110b","hasScoped":false}!./src/app/components/productTableWithCustomForm/productTableWithCustomForm.html
// module id = 3070
// module chunks = 1